module.exports = __webpack_public_path__ + "static/img/MANHATTAN-ANTIQUE-WHITE.fa67835.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/MANHATTAN-ANTIQUE-WHITE.png
// module id = kx1T
// module chunks = 0